"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SetPageCTATypes = void 0;
exports.SetPageCTATypes = [
    "link",
    "email",
    "phone",
    "text",
    "form",
    "mailchimp",
];
//# sourceMappingURL=CTA.js.map